<template>
  <component
    :is="tag"
    :class="[
      // Base class
      'v-text',

      // Font-size classes
      `v-text--size-${fontSize}`,
      !!fontMdSize && `v-text--size-md-${fontMdSize}`,
      !!fontLgSize && `v-text--size-lg-${fontLgSize}`,

      // Font weight and italic
      bold && 'font-weight-bold',
      italic && 'font-italic',
    ]"
  >
    <slot></slot>
  </component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: "div"
    },
    fontSize: {
      type: String,
      default: "3"
    },
    fontMdSize: {
      type: String,
      default: null
    },
    fontLgSize: {
      type: String,
      default: null
    },
    bold: {
      type: Boolean,
      default: false
    },
    italic: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

// Mixin that generates all the classes
@mixin textSizeClasses($breakpoint: null) {
  @each $size in $fontSizes {
    $index: index($fontSizes, $size);

    &--size#{if($breakpoint, '-' + $breakpoint, '')}-#{$index} {
      // Font size
      @include font-size($size);

      // Line height
      @if $index >= 9 {
        line-height: 1;
      } @else if $index == 8 {
        line-height: 1.125;
      } @else if $index >= 6 {
        line-height: 1.25;
      } @else {
        line-height: 1.5;
      }

      // Letter spacing
      @if $index >= 7 {
        letter-spacing: -0.5px;
      } @else {
        letter-spacing: normal;
      }
    }
  }
}

.v-text {
  // Make sure font-weight is default as normal (h1, h2, h3)
  font-weight: normal;
  margin: 0;
  padding: 0;
  border: 0;

  // Size classes for small and up
  @include textSizeClasses();

  // Size classes for medium and up
  @include media-breakpoint-up(md) {
    @include textSizeClasses(md);
  }

  // Size classes for large and up
  @include media-breakpoint-up(lg) {
    @include textSizeClasses(lg);
  }

  // Headings
  h1 {
    @include font-size(nth($fontSizes, 8));
    line-height: 1.125;
    font-weight: bold;
  }

  h2 {
    @include font-size(nth($fontSizes, 7));
    line-height: 1.25;
    font-weight: bold;
  }

  h3 {
    @include font-size(nth($fontSizes, 6));
    line-height: 1.25;
    font-weight: bold;
  }

  h4 {
    @include font-size(nth($fontSizes, 5));
    line-height: 1.5;
    font-weight: bold;
  }

  h5 {
    @include font-size(nth($fontSizes, 4));
    line-height: 1.5;
    font-weight: bold;
  }

  h6 {
    @include font-size(nth($fontSizes, 3));
    line-height: 1.5;
    font-weight: bold;
  }
}
</style>
